import { render } from "./WalletWithdrawal.vue?vue&type=template&id=161903fe&scoped=true"
import script from "./WalletWithdrawal.vue?vue&type=script&lang=js"
export * from "./WalletWithdrawal.vue?vue&type=script&lang=js"

import "./WalletWithdrawal.vue?vue&type=style&index=0&id=161903fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161903fe"]])

export default __exports__